export const name = "DATETIME_ADD";
export const summary = `Adds a specified time interval to a \`DATETIME\` value.`;
export const reference = `
## DATETIME_ADD

Adds a specified time interval to a \`DATETIME\` value.

\`\`\`
DATETIME_ADD(datetime_expression, INTERVAL int64_expression part)
\`\`\`

### Description

Adds \`int64_expression\` units of \`part\` to the \`DATETIME\` object.

\`DATETIME_ADD\` supports the following values for \`part\`:

- \`MICROSECOND\`
- \`MILLISECOND\`
- \`SECOND\`
- \`MINUTE\`
- \`HOUR\`
- \`DAY\`
- \`WEEK\`. Equivalent to 7 \`DAY\`s.
- \`MONTH\`
- \`QUARTER\`
- \`YEAR\`

Special handling is required for MONTH, QUARTER, and YEAR parts when the date is at (or near) the last day of the month. If the resulting month has fewer days than the original DATETIME's day, then the result day is the last day of the new month.


### Return Data Type

\`DATETIME\`


### Example



\`\`\`
SELECT
  DATETIME "2008-12-25 15:30:00" as original_date,
  DATETIME_ADD(DATETIME "2008-12-25 15:30:00", INTERVAL 10 MINUTE) as later;

/*-----------------------------+------------------------*
 | original_date | later |
 +-----------------------------+------------------------+
 | 2008-12-25T15:30:00 | 2008-12-25T15:40:00 |
 *-----------------------------+------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/datetime_functions
`;
